import m from "mithril";
import _ from "underscore";

import {elementId} from "./helpers";
import {ComboItem} from "../../model/items/combo";
import {inputTextItemView} from "./inputText";

export function comboItemView(c: ComboItem) {
    const options = c.getOptions();
    const width = c.getGroup().displayWidth + 'px';

    // null or undefined are empty values => show prompt
    const currentValue: string = (c.getVariable() === undefined || c.getVariable() === null) ? '' : ''+c.getVariable();

    return m('.combo', [
        m('select', {
                value: currentValue,
                disabled: !c.cell.enabled,
                style: {
                    id: elementId(c, c.cell.id),
                    width: width,
                    minWidth: width
                },
                onchange: m.withAttr("value", c.set.bind(c))
            }, _.map(options, (o) => {
                const optionValue: string = (o.value === undefined || o.value === null) ? '' : ''+o.value;
                return m('option', {
                    value: optionValue,
                    selected: currentValue === optionValue ? 'selected' : null
                }, c.questionary.renderText(o.name))
            })
        ),
        c.cell.hasInputText() ? inputTextItemView(c.cell.getInputText()!) : ''
    ]);
}